import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks'
import { LoadingSpinner } from '@/components/shared'

export function LogoutPage() {
  const navigate = useNavigate()
  const { signOut } = useAuth()

  useEffect(() => {
    const doLogout = async () => {
      // Sign out from Firebase and clear auth state
      await signOut()

      // Clear ALL localStorage to nuke any stale state
      localStorage.clear()

      // Clear sessionStorage too
      sessionStorage.clear()

      // Redirect to login
      navigate('/login', { replace: true })
    }

    doLogout()
  }, [signOut, navigate])

  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-sm text-gray-500">Logging out...</p>
      </div>
    </div>
  )
}
